/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 01.09.2014
 *   Time: 12:23
 */

import { IBaseEnvironmentData } from "../data/IBaseEnvironmentData";
import { IPathFactory } from "./IPathFactory";
import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger("PathFactory");

export class PathFactory implements IPathFactory {
    private static REGEXP_STRIP_WHITES: RegExp = /^\s+|\s+$/g;
    private static REGEXP_STRIP_CURLY: RegExp = /^\{|\}$/g;
    private static REGEXP_DEFAULT_REPLACEMENT: RegExp = /\{.*?\}/g;

    public build(pattern: string, data: IBaseEnvironmentData): string {
        let result: string = pattern.replace(PathFactory.REGEXP_STRIP_WHITES, "");
        const replacements: RegExpMatchArray | null = pattern.match(PathFactory.REGEXP_DEFAULT_REPLACEMENT);

        if (replacements) {
            for (let key of replacements) {
                key = key.replace(PathFactory.REGEXP_STRIP_CURLY, "").replace(PathFactory.REGEXP_STRIP_WHITES, '');

                const value = data[key];

                if (!value) {
                    // TODO: @HTML5 throw error when invalid configuration is detected.
                    logger.warn("The environment setting '" + key + "' is not valid.");
                    // throw new Error("The environment setting '" + key + "' is not valid.");
                }

                try {
                    const regexp = new RegExp("\\{\\s*" + key + "\\s*\\}", "gi");
                    result = result.replace(regexp, value);
                } catch (e) {
                    logger.error(`Replacing with RegExp failed for key`, key, e, result);
                }
            }
        }

        return result;
    }
}
